import React, { FC, memo } from 'react'

import { MainSidebar } from '@/components/MainSidebar/MainSidebar'
import { focusIds } from '@/constants/focus'
import { EventDetailPage } from '@/containers/EventDetailPage/EventDetailPage'
import { Container } from '@/containers/styles'
import { useOpenPrevEventPopup } from '@/hooks/useOpenPrevEventPopup'

const EventDetailsPopupRaw: FC = () => {
  const openPrevEventPopup = useOpenPrevEventPopup()

  return (
    <Container focusId={`${focusIds.EVENT_PAGE}${focusIds.CONTENT}`}>
      <MainSidebar
        focusIdPrefix={focusIds.EVENT_PAGE}
        onBack={openPrevEventPopup}
        disableSubMenuAutoOpen
      />
      <EventDetailPage />
    </Container>
  )
}

export const EventDetailPageWithSidebar = memo(EventDetailsPopupRaw)
